import { action, observable, makeObservable } from 'mobx';
import axios from 'axios';
import getSortType from '../utils/getSortType';
import { getSortKeysForUserActivitiesData } from '../pages/UserActivitiesPage/userActivitiesColumns';
import i18next from 'i18next';

const { REACT_APP_API_URL } = process.env;

class UserActivitiesStore {
  constructor(profileStore) {
    makeObservable(this, {
      userActivities: observable,
      loadingUserActivities: observable,
      getUserActivities: action,
      resetUserActivities: action
    });

    this.profileStore = profileStore;
  }

  userActivities = [];

  loadingUserActivities = false;

  getUserActivities = async (userId, { column, type }) => {
    const authToken = await this.profileStore.getAuthToken();

    const sort = getSortType(type, getSortKeysForUserActivitiesData(column));
    try {
      const { data } = await axios.get(
        `${REACT_APP_API_URL}/users/activities/${encodeURIComponent(userId)}?lng=${i18next.language}&sort=${sort}`,
        {
          headers: { Authorization: `Bearer ${authToken}` },
        }
      );

      this.userActivities = data;
    } catch (err) {
      this.userActivities = [];
      this.loadingDevices = false;
    }
  };

  resetUserActivities = () => {
    this.userActivities = [];
  };
}

export default UserActivitiesStore;
